(function () {
	let homieHost = null;
	let homieWidget = null;
	function applyWidgetStyle() {
		if (!homieWidget) return;
		homieWidget.style.setProperty('max-height', '80dvh', 'important');
	}

	function styleHomieWidget(hostEl) {
		if (!hostEl || !hostEl.shadowRoot) return;

		homieHost = hostEl;

		const widget = hostEl.shadowRoot.getElementById('homie-chatbot-widget');
		if (!widget) return;

		homieWidget = widget;
		applyWidgetStyle();

		// Add a window resize listener once
		if (!window.__homieResizeListenerAttached) {
			window.addEventListener('resize', () => {
				// Small delay in case Homie updates styles *during* resize
				setTimeout(applyWidgetStyle, 0);
			});
			window.__homieResizeListenerAttached = true;
		}
	}

	function onHomieHostFound(hostEl) {
		styleHomieWidget(hostEl);
	}

	const homieHostObserver = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (!(node instanceof HTMLElement)) continue;

				if (node.id === 'homie-shadow-host') {
					onHomieHostFound(node);
				}
				const innerHost = node.querySelector?.('#homie-shadow-host');
				if (innerHost) {
					onHomieHostFound(innerHost);
				}
			}
		}
	});
	homieHostObserver.observe(document.documentElement || document.body, {
		childList: true,
		subtree: true,
	});
	const existingHost = document.getElementById('homie-shadow-host');
	if (existingHost) {
		onHomieHostFound(existingHost);
	}
})();
